//CADASTRO QUE VEM DA PARTE DE ENVIO PARA QUE O ANALISTA SEJA CAPAZ DE VISUALIZAR INFORMAÇÕES
import { useEffect, useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import "./CadastroTab.css";

export interface CadastroAnalysisFormData {
  nome: string;
  cnpj: string;
  sigla: string;
  regional: string;
  ordenacao: string;
  grupo: string;
  presidente: string;
  email: string;
  telefone: string;
  coordenador: string;
  telCoordenador: string;
  responsavel: string;
  cargo: string;
}

export interface CadastroAnalysisProps {
  idResposta: string;
  idSindicato: string;
  resposta: { json: string | Record<string, unknown> };
  sindicato: Record<string, unknown>;
}

const CadastroAnalysis = ({ idResposta, idSindicato, resposta, sindicato }: CadastroAnalysisProps) => {
  const [formData, setFormData] = useState<CadastroAnalysisFormData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!resposta || !sindicato) return;

    const jsonData =
      typeof resposta.json === "string"
        ? JSON.parse(resposta.json)
        : resposta.json || {};

    setFormData({
      nome: String(sindicato.nome ?? ""),
      cnpj: String(sindicato.cnpj ?? ""),
      sigla: String(sindicato.sigla ?? ""),
      regional: String(sindicato.regional ?? ""),
      ordenacao: String(sindicato.ordenacao ?? ""),
      grupo: String(sindicato.grupo ?? ""),
      presidente: String(sindicato.nomePresidente ?? ""),
      email: String(sindicato.emailSindicato ?? ""),
      telefone: String(jsonData.telefoneSindicato ?? sindicato.telefoneSindicato ?? ""),
      coordenador: String(jsonData.nomeCoordenador ?? sindicato.nomeCoordenador ?? ""),
      telCoordenador: String(jsonData.telefoneCoordenador ?? sindicato.telefoneCoordenador ?? ""),
      responsavel: String(jsonData.responsavelPreenchimento ?? sindicato.responsavelPreenchimento ?? ""),
      cargo: String(jsonData.cargoResponsavel ?? sindicato.cargoResponsavel ?? ""),
    });

    setLoading(false);
  }, [resposta, sindicato]);

  const formatCNPJ = (cnpj: string) => {
    if (!cnpj) return "";
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  };

  if (loading || !formData) return <PageLoading />;

  return (
    <Container className="cadastro-container">
      <h1 className="cadastro-title">DADOS DO SINDICATO</h1>
      <div className="alert alert-warning" role="alert">
        Este formulário está bloqueado para edição. Os campos abaixo são apenas
        para visualização do analista.
      </div>
      <Form>
        <Row className="gy-3">
          {Object.entries(formData).map(([key, value]) => (
            <Col md={6} key={key}>
              <Form.Group>
                <Form.Label className="cadastro-label">
                  {key.replace(/([A-Z])/g, " $1").toUpperCase()}
                </Form.Label>
                <Form.Control
                  value={key === "cnpj" ? formatCNPJ(value) : value}
                  disabled
                  className="field-disabled"
                />
              </Form.Group>
            </Col>
          ))}
        </Row>
      </Form>
    </Container>
  );
};

export default CadastroAnalysis;
